module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Mirror-7ff030856fe3bad51a7bf036c9ffc15bef43468f98cd0e9f78508acef90e8baf.svg";